<script>
  import { onMount, createEventDispatcher } from "svelte";
  import Icon from "./helpers/Icon.svelte";
  import { audioActive } from "../stores/global.js";
  export let name;
  export let active;

  const slug = name.replace(/\W/, "").toLowerCase();

  const onClick = () => {
    if ($audioActive) $audioActive = $audioActive === slug ? null : slug;
    else $audioActive = slug;
  };

  $: active = $audioActive === slug;
</script>

<div class="player" class:active>
  <button class="icon" on:click="{onClick}" id="ad-{slug}">
    <Icon
      stroke-width="1px"
      stroke="#000000"
      name="{active ? 'pause' : 'play'}"
    />
  </button>
</div>

<style>
  .player {
    position: relative;
  }

  button {
    background-color: transparent;
    transition: all 0.25s ease-out;
    pointer-events: auto;
    /* display: flex; */
  }

  .active button {
    /* transform: translate(-50%, -50%) scale(1.75); */
  }
</style>
